const checkboxes = document.querySelectorAll('input[name="checkbox-group"]');
const info1 = document.querySelector("#info1");
const info2 = document.querySelector("#info2");
const info1_2 = document.querySelector("#info1_2");
const info2_2 = document.querySelector("#info2_2");
const plan_1 = document.querySelector("#select-plan-1");
const plan_2 = document.querySelector("#select-plan-2");

checkboxes.forEach((checkbox) => {
  checkbox.addEventListener("change", () => {
    if (checkbox.checked) {
      if (checkbox === checkboxes[0]) {
        checkboxes[1].checked = false;
        info1.style.display = "flex";
        info2.style.display = "none";
        plan_1.classList.add("checked");
        plan_2.classList.remove("checked");
      } else {
        checkboxes[0].checked = false;
        info1.style.display = "none";
        info2.style.display = "flex";
        plan_1.classList.remove("checked");
        plan_2.classList.add("checked");
      }
    } else if (!checkboxes[0].checked && !checkboxes[1].checked) {
      checkboxes[0].checked = true;
    }
  });
});
